import { RootState } from "../reducers"

export const selectDepositAmount = (state: RootState) =>
  state.deposit.depositAmount

export const selectLockTime = (state: RootState) => state.deposit.lockTime

export const selectActiveToken = (state: RootState) => state.deposit.activeToken

export const selectDepositStatus = (state: RootState) =>
  state.deposit.depositStatus

export const selectDepositModalClosed = (state: RootState) =>
  state.deposit.depositModalClosed

export const selectTokenApprovalStatus = (state: RootState) =>
  state.deposit.tokenApprovalStatus

export const selectDepositId = (state: RootState) => state.deposit.depositId

export const selectHasDepositError = (state: RootState) =>
  state.deposit.hasDepositError

export const selectHasApprovalError = (state: RootState) =>
  state.deposit.hasApprovalError
